import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { OrganizationApi } from "../../../../../../../../../../../services/Api/types";

interface Props {
	form: UseFormReturn<OrganizationApi>;
}

const OrganizationAddressForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<>
			<div className={"row row-cols-md-2"}>
				<div className="col-md-6">
					<div className={"row row-cols-md-2"}>
						<div className="col-md-6">
							<FormInput
								label={t("lib:common.address.country")}
								register={register}
								name="place.country"
								errors={errors}
							/>
						</div>
						<div className="col-md-6">
							<FormInput
								label={t("lib:common.address.zip_code")}
								register={register}
								name="place.zip_code"
								errors={errors}
							/>
						</div>
					</div>
				</div>
				<div className="col-md-6">
					<FormInput
						label={t("lib:common.address.city")}
						register={register}
						name="place.city"
						errors={errors}
					/>
				</div>
			</div>
			<div className={"row row-cols-md-2"}>
				<div className="col-md-6">
					<FormInput
						label={t("lib:common.address.street")}
						register={register}
						name="place.street"
						errors={errors}
					/>
				</div>
				<div className="col-md-6">
					<div className={"row row-cols-md-2"}>
						<div className="col-md-6">
							<FormInput
								label={t("lib:common.address.build_nr")}
								register={register}
								name="place.build_nr"
								errors={errors}
							/>
						</div>
						<div className="col-md-6">
							<FormInput
								label={t("lib:common.address.flat_nr")}
								register={register}
								name="place.flat_nr"
								errors={errors}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default OrganizationAddressForm;
